import type { Loan } from './loans.ts';
import type { Reconciliation } from './reconcile.ts';
import type { Account, Entry, People } from './schemas.ts';

// The bank's live topics (design §6.5, plan 2A Assumption 11).

/** Balances, for holders of bank.view: a SummaryChange. */
export const SUMMARY_TOPIC = 'bank.summary';

/** Entries as they're recorded and decided, for holders of bank.view_ledger: a LedgerChange. */
export const LEDGER_TOPIC = 'bank.ledger';

/** The pending queue, for holders of bank.approve. */
export const APPROVALS_TOPIC = 'bank.approvals';

/** The personal topic's name, without its param. */
export const ME_TOPIC = 'bank.me';

/** Things waiting on one user; only that user may subscribe. */
export function meTopic(userId: string): string {
  return `${ME_TOPIC}:${userId}`;
}

/** An account was created, changed or had its balance moved. Clients recompute the total. */
export interface AccountChange {
  type: 'account';
  account: Account;
  people: People;
}

/** A reconciliation opened, was reported or was missed. */
export interface ReconciliationChange {
  type: 'reconciliation';
  reconciliation: Reconciliation;
}

/** A period closed and the next began: fetch the summary again. */
export interface PeriodChange {
  type: 'period';
  number: number;
}

/** What bank.summary carries. */
export type SummaryChange = AccountChange | ReconciliationChange | PeriodChange;

/** An entry was recorded, or its status changed. */
export interface EntryChange {
  type: 'entry';
  entry: Entry;
  people: People;
}

/** A loan was created, edited, lent, repaid or written off: its whole view. */
export interface LoanChange {
  type: 'loan';
  loan: Loan;
  people: People;
}

/** A loan that was deleted. */
export interface LoanRemoved {
  type: 'loan_removed';
  id: string;
}

/** What bank.ledger carries. */
export type LedgerChange = EntryChange | LoanChange | LoanRemoved;
